import { useState } from 'react';
import './name.css';
import lockShieldImg from '../assets/icon.png';

function ChevronLeftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PersonIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.4" stroke="#8a6df1" strokeWidth="1.8" />
      <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" stroke="#8a6df1" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function NameStep({ onBack, onContinue }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const isComplete = firstName.trim().length > 0 && lastName.trim().length > 0;

  return (
    <div className="name-screen">
      <div className="name-frame">
        <div className="name-header">
          <button type="button" className="name-back-btn" onClick={onBack} aria-label="Go back">
            <ChevronLeftIcon />
          </button>

          <div className="name-glow" />
          <div className="name-icon-wrap">
            <img src={lockShieldImg} alt="" className="name-icon-img" />
          </div>
          <h1 className="name-title">Almost There!</h1>
          <p className="name-subtitle">Let&apos;s get to know you better</p>
        </div>

        <form
          className="name-card"
          onSubmit={(e) => {
            e.preventDefault();
            if (isComplete) onContinue?.({ firstName, lastName });
          }}
        >
          <h2 className="name-card-title">What&apos;s your name?</h2>
          <p className="name-card-subtitle">Please enter your full name</p>

          <div className="name-field">
            <label className="name-label" htmlFor="first-name">
              First Name
            </label>
            <div className="name-input-wrap">
              <PersonIcon />
              <input
                id="first-name"
                type="text"
                placeholder="Enter your first name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </div>

          <div className="name-field">
            <label className="name-label" htmlFor="last-name">
              Last Name
            </label>
            <div className="name-input-wrap">
              <PersonIcon />
              <input
                id="last-name"
                type="text"
                placeholder="Enter your last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className="name-submit" disabled={!isComplete}>
            Next <ArrowRightIcon />
          </button>
        </form>
      </div>
    </div>
  );
}
